import React from 'react'
/* eslint-disable react/forbid-prop-types */
import { any } from 'prop-types'
import PermissionRouteWithFallback from './PermissionRouteWithFallback'

/**
 * Gates the Human Review AI Content admin pages on the same permission discovery-ai enforces.
 *
 * discovery-ai's SecurityConfiguration puts /manage/** behind DiscoveryContentReviewPermission,
 * which exists so reviewers can be recruited without being handed DiscoveryDatabasePermission and
 * everything else it opens. Checking it here rather than a coarser admin permission means someone
 * without it gets Unauthorized instead of a page that renders and then 403s on every call.
 */
export default function ContentReviewPermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  return (
    <PermissionRouteWithFallback
      component={Component}
      path={path}
      exact={exact}
      fallback={Fallback}
      requirePersonalData={requirePersonalData}
      permissionName="DiscoveryContentReviewPermission"
      permissionContext="DiscoveryManageContentContext"
    >
      {children}
    </PermissionRouteWithFallback>
  )
}

ContentReviewPermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  path: any,
  exact: any,
  requirePersonalData: any,
}
